import { captureException } from '@sentry/react'
import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { httpLogin } from '@/features/auth/http/auth.http'
import type { LoginValidationSchema } from '@/features/auth/login-form-model'
import { HttpLoginResponse } from '@/features/auth/types.ts'
import { parseAxiosPromise } from '@/helpers/utils'
import { MUTATION_KEYS } from '@/query-client'
import type { ErrorResponseData } from '@/types/commons.ts'

interface useLoginProps {
	onSuccess?: (data: HttpLoginResponse) => void
	onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useLogin = (options?: useLoginProps) => {
	return useMutation({
		mutationKey: [MUTATION_KEYS.LOGIN],
		mutationFn: (params: LoginValidationSchema) =>
			parseAxiosPromise({
				axiosPromise: httpLogin(params),
				onZodError: captureException,
				responseShape: HttpLoginResponse
			}),
		onError: (error: AxiosError<ErrorResponseData>) =>
			options?.onError?.(error),
		onSuccess: (data) => options?.onSuccess?.(data)
	})
}
